exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".supplier-list-branches span {\n  font-size: 80%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/accounting/branches/branches-list/branches-list.component.scss
// module id = ../../../../../src/app/agatextscreens/accounting/branches/branches-list/branches-list.component.scss
// module chunks = 0